import React from 'react'
import { MenuDivider, csx } from '@vtex/admin-ui'

export const Separator = () => (
  <MenuDivider
    className={csx({
      borderColor: '#E0E0E0', // [TODO]<theme>
      marginY: '$space-6',
      marginX: '-4',
      '@tablet': {
        marginX: '$space-0',
      },
      '@desktop': {
        display: 'none',
      },
    })}
  />
)
